import React from "react";
import CommonCard from "../CommonCard";

const ImliRange = ({ products, title }) => {
  return (
    <>
    <CommonCard 
     products={products}
     title={title}
    />
    </>
  );
};

export default ImliRange;